export const getLiveCursorPositions = (state) => state.get('liveCursor');
